"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationList = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _PaginationItem = require("./PaginationItem");

var _utils = require("./utils");

var PaginationList = function PaginationList(_ref) {
  var left = _ref.left,
      length = _ref.length,
      currentPage = _ref.currentPage,
      linkBase = _ref.linkBase;
  var lengthArr = (0, _toConsumableArray2["default"])(Array(length));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, lengthArr.map(function (_, i) {
    var pageNumber = left + i;

    if (pageNumber === currentPage) {
      return /*#__PURE__*/_react["default"].createElement(_PaginationItem.CurrentItem, {
        key: pageNumber
      }, currentPage);
    }

    return /*#__PURE__*/_react["default"].createElement(_PaginationItem.NumberLink, {
      href: (0, _utils.buildLink)(linkBase, pageNumber),
      key: pageNumber
    }, pageNumber);
  }));
};

exports.PaginationList = PaginationList;